(function() {
  // Prevent duplicate event listeners if the section is included multiple times
  if (window.SaleBannerTooltipInitialized) return;
  window.SaleBannerTooltipInitialized = true;

  // Function to initialize all modals on the page
  function initializeModals() {
    const offerBanners = document.querySelectorAll('.js-offer-banner');

    offerBanners.forEach((banner, index) => {
      let modal = banner.querySelector('.productGrid__bmsmModal');
      
      if (!modal) {
        let currentElement = banner.nextElementSibling;
        while (currentElement) {
          if (currentElement.classList.contains('productGrid__bmsmModal') || 
              currentElement.classList.contains('js-offer-tooltip')) {
            modal = currentElement;
            break;
          }
          currentElement = currentElement.nextElementSibling;
        }
      }
      
      if (!modal) return;

      const modalId = `offer-tooltip-${index}`;
      modal.id = modalId;

      const toggleButtons = banner.querySelectorAll('.js-tooltip-toggle');
      toggleButtons.forEach(button => {
        button.setAttribute('aria-controls', modalId);
        button.setAttribute('aria-expanded', 'false');
      });
      
      const closeButtons = modal.querySelectorAll('.js-tooltip-toggle');
      closeButtons.forEach(button => {
        button.setAttribute('aria-controls', modalId);
        button.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function getBannerForModal(modal) {
    let banner = modal.closest('.js-offer-banner');
    
    if (!banner) {
      let currentElement = modal.previousElementSibling;
      while (currentElement) {
        if (currentElement.classList.contains('js-offer-banner')) {
          banner = currentElement;
          break;
        }
        currentElement = currentElement.previousElementSibling;
      }
    }
    return banner;
  }

  function getModalBgForModal(modal) {
    const banner = getBannerForModal(modal);
    let modalBg = banner?.querySelector('.productGrid__bmsmModalBg');
    
    if (!modalBg) {
      let currentElement = modal.nextElementSibling;
      while (currentElement) {
        if (currentElement.classList.contains('productGrid__bmsmModalBg')) {
          modalBg = currentElement;
          break;
        }
        currentElement = currentElement.nextElementSibling;
      }
    }
    return modalBg;
  }

  function closeAllModals() {
    document.querySelectorAll('.productGrid__bmsmModal.is--active, .js-offer-tooltip.is--active').forEach(modal => {
      modal.classList.remove('is--active');
      const modalId = modal.id;
      const banner = getBannerForModal(modal);

      if (banner) {
        banner.classList.remove('show-banner');
      }

      const modalBg = getModalBgForModal(modal);
      if (modalBg) {
        modalBg.classList.remove('is--active');
      }

      document.querySelectorAll(`[aria-controls="${modalId}"]`).forEach(button => {
        button.setAttribute('aria-expanded', 'false');
      });
    });
    
    document.body.classList.remove('overflow-hidden');
  }

  // --- SINGLE EVENT LISTENER FOR ALL CLICKS ---
  document.addEventListener('click', function(event) {
    const toggleButton = event.target.closest('.js-tooltip-toggle');

    if (toggleButton) {
      event.preventDefault();
      
      if (toggleButton.classList.contains('productGrid__bmsmModalBg')) {
        closeAllModals();
        return;
      }
      
      const modalId = toggleButton.getAttribute('aria-controls');
      let modal = document.getElementById(modalId);

      if (!modal) {
        const banner = toggleButton.closest('.js-offer-banner');
        if (banner) {
          modal = banner.querySelector('.productGrid__bmsmModal, .js-offer-tooltip');
          
          if (!modal) {
            let currentElement = banner.nextElementSibling;
            while (currentElement) {
              if (currentElement.classList.contains('productGrid__bmsmModal') || 
                  currentElement.classList.contains('js-offer-tooltip')) {
                modal = currentElement;
                break;
              }
              currentElement = currentElement.nextElementSibling;
            }
          }
        }
      }

      if (modal) {
        const isExpanded = modal.classList.contains('is--active');
        const banner = getBannerForModal(modal);
        const modalBg = getModalBgForModal(modal);

        // Always close any open modals first
        closeAllModals();

        // If the clicked modal was not already open, then open it.
        if (!isExpanded) {
          modal.classList.add('is--active');
          
          if (banner && window.matchMedia('(max-width: 1024px)').matches) {
            banner.classList.add('show-banner');
          }
          
          if (modalBg) {
            modalBg.classList.add('is--active');
          }
          
          if (modal.id) {
            document.querySelectorAll(`[aria-controls="${modal.id}"]`).forEach(button => {
              button.setAttribute('aria-expanded', 'true');
            });
          }
          
          if (window.matchMedia('(max-width: 1024px)').matches) {
            document.body.classList.add('overflow-hidden');
          }
        }
      }
      return;
    }

    const clickedInsideModal = event.target.closest('.productGrid__bmsmModal, .js-offer-tooltip');
    if (!clickedInsideModal) {
      closeAllModals();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeAllModals();
    }
  });

  window.initializeModals = initializeModals;

  // Safer initialization in case the script loads slightly after DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeModals);
  } else {
    initializeModals();
  }
})();